// extracted by mini-css-extract-plugin
export var content = "Hero-module--content--106Q1";
export var heading = "Hero-module--heading--etwVP";
export var subheading = "Hero-module--subheading--4s7BC";
export var wrapper = "Hero-module--wrapper--Hr6i7";